import React from "react";

/**
 * InfiniteEmployeeScroll is a simple wrapper for infinite scroll functionality.
 * It expects:
 * - dataLength: number of items currently loaded
 * - next: function to call to load more items
 * - hasMore: boolean, if more items are available
 * - loader: React node to show while loading
 * - children: the list to render
 */
export default function InfiniteEmployeeScroll({ dataLength, next, hasMore, loader, children }) {
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 10 && hasMore) {
      next();
    }
  };

  return (
    <div style={{ overflowY: "auto", maxHeight: 200 }} onScroll={handleScroll}>
      {children}
      {hasMore && loader}
    </div>
  );
}
